import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { RouteLoadingService } from '../../../../core/services/route-loading.service';

@Component({
  selector: 'app-route-progress',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [`
    .progress-bar {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      height: 3px;
      z-index: 9998;
      overflow: hidden;
      background: transparent;
    }
    .progress-bar.active {
      background: rgba(6, 182, 212, 0.15);
    }
    .progress-track {
      height: 100%;
      background: linear-gradient(90deg, #06b6d4, #3b82f6, #06b6d4);
      background-size: 200% 100%;
      animation: slide 1.4s ease-in-out infinite;
      transform-origin: left;
    }
    @keyframes slide {
      0%   { background-position: 200% 0; }
      100% { background-position: -200% 0; }
    }
  `],
  template: `
    <div class="progress-bar" [class.active]="loader.loading()">
      @if (loader.loading()) {
        <div class="progress-track"></div>
      }
    </div>
  `,
})
export class RouteProgressComponent {
  readonly loader = inject(RouteLoadingService);
}
